export default function IconBin({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.54 0.53 16.94 16.94"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M1.7959 5.04159L16.2345 1.97266"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1245 1.11558L7.03169 1.77281C6.89588 1.80137 6.76704 1.85647 6.65256 1.93494C6.53809 2.01341 6.44023 2.11371 6.36461 2.23009C6.28899 2.34646 6.23708 2.47662 6.21187 2.6131C6.18667 2.74958 6.18865 2.88969 6.21771 3.0254L6.43702 4.05729L11.5936 2.96074L11.3743 1.92956C11.3457 1.79403 11.2907 1.66547 11.2124 1.5512C11.1341 1.43694 11.0341 1.33923 10.9181 1.26364C10.802 1.18805 10.6722 1.13606 10.536 1.11066C10.3999 1.08526 10.26 1.08693 10.1245 1.11558Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.12207 13.2172V7.94531"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2852 13.2172V7.94531"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6571 4.78223H15.5022L14.5287 15.9403C14.5068 16.2046 14.3861 16.4509 14.1907 16.6301C13.9953 16.8094 13.7395 16.9084 13.4743 16.9075H5.9285C5.66405 16.9074 5.40932 16.8079 5.21481 16.6287C5.02029 16.4496 4.9002 16.2039 4.87834 15.9403L4.14941 7.15598"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
